/* eslint-disable func-names */
import React, { Component } from "react";
import { connect } from "react-redux";
import { Route, Switch, useHistory } from "react-router-dom";
import * as moment from 'moment'
import { QRCodeCanvas } from "qrcode.react"
import { updateAutoP2PPayment } from "../../actions"
import { CONFIGS } from '../../configs'
import { _formatCurrency } from '../../utils'
import { QRPay, BanksObject } from 'vietnam-qr-pay';

import { CircleSpinnerOverlay, FerrisWheelSpinner } from 'react-spinner-overlay'

import {
    Badge,
    Button,
    Card,
    Form,
    Navbar,
    Nav,
    Container,
    Row,
    Col,
    InputGroup,
    Collapse,
    Modal,
    Table
} from "react-bootstrap";
import { basename } from "path";

class AutoP2PPayment extends Component {
    constructor() {
        super();

        this.state = {
            payment: "",
            paymentOption: ""
        }

        this.bankBins = {
            "VIETCOMBANK": BanksObject.vietcombank.bin,
            "SACOMBANK": BanksObject.sacombank.bin,
            "TECHCOMBANK": BanksObject.techcombank.bin,
        }
    }

    componentDidMount() {
        this.setState({ payment: this.props.payment, paymentOption: this.props.paymentOption })
    }

    componentWillReceiveProps(props) {
        if (props.payment)
            this.setState({ payment: props.payment, paymentOption: props.paymentOption })
    }

    handleChangeFullName = (e) => {
        this.setState({
            payment: { ...this.state.payment, full_name: e.target.value }
        })
    }

    handleChangeAccountNumber = (e) => {
        this.setState({
            payment: { ...this.state.payment, account_number: e.target.value }
        })
    }

    handleChangeMessage = (e) => {
        this.setState({
            payment: { ...this.state.payment, message: e.target.value }
        })
    }

    handleSelectBank = (e) => {
        this.setState({
            payment: { ...this.state.payment, bank_name: e.target.value }
        })
    }

    renderQR = (payment) => {
        console.log("@@@ ", 
            this.bankBins[payment.bank_name], 
            payment.account_number, 
            payment.amount,
        payment.message);

        const qrPay = QRPay.initVietQR({
            bankBin: this.bankBins[payment.bank_name],
            bankNumber: payment.account_number, // Số tài khoản
            amount: `${payment.amount}`, // Số tiền
            purpose: payment.message, // Nội dung chuyển tiền
        })
        const content = qrPay.build()

        return content;
    }

    handleSubmit = () => {
        this.props.updateAutoP2PPayment(this.state.payment);
    }

    handleConfirmPayment = () => {
        this.props.updateAutoP2PPayment({
            ...this.state.payment,
            status: CONFIGS.AUTOP2P_PAYMENT_STATUS.CONFIRMED
        });
    }

    render() {
        console.log("@@@ AutoP2PPayment state", this.state);
        var { payment, paymentOption } = this.state;

        if (!payment || !paymentOption)
            return "";

        var message = payment.message;

        if (paymentOption == CONFIGS.AUTOP2P_PAYMENT_OPTIONS.ORDER_ID)
            message = payment.order_id;
        else if (paymentOption == CONFIGS.AUTOP2P_PAYMENT_OPTIONS.TEMPLATE_1)
            message = CONFIGS.AUTOP2P_PAYMENT_MESSAGES[0];
        else if (paymentOption == CONFIGS.AUTOP2P_PAYMENT_OPTIONS.TEMPLATE_2)
            message = CONFIGS.AUTOP2P_PAYMENT_MESSAGES[1];

        return (
            <Row className="payment-item">
                <Col md="5" className="extra-infos">
                    <Row>
                        {payment.extra_infos.map((info, index) => {
                            var element = (index % 2 == 0) ?
                                <b>{info}</b> : info;

                            // if (index > 0)
                            return <Col sm="6">{element}</Col>
                        })}
                    </Row>

                </Col>
                <Col md="7">
                    <Row style={{ height: "100%" }}>
                        <Col md="7" className="pl-4">
                            {/* <Row className="mt-3">
                <h4>THÔNG TIN CHUYỂN KHOẢN</h4>
                </Row> */}
                            <Row className="mt-3">
                                <InputGroup className="mb-1">
                                    <InputGroup.Text>ORDER ID</InputGroup.Text>
                                    <Form.Control
                                        value={payment.order_id}
                                        disabled={true}
                                    />
                                </InputGroup>
                            </Row>
                            <Row>
                                <InputGroup className="mb-2">
                                    <InputGroup.Text>HỌ TÊN</InputGroup.Text>
                                    <Form.Control
                                        value={payment.full_name}
                                        onChange={this.handleChangeFullName}
                                    />
                                </InputGroup>
                            </Row>
                            <Row>
                                <InputGroup className="mb-2">
                                    <InputGroup.Text>NGÂN HÀNG</InputGroup.Text>
                                    <Form.Select
                                        value={payment.bank_name}
                                        onChange={this.handleSelectBank}
                                    >
                                        {Object.keys(this.bankBins).map(bankName => <option value={bankName}>{bankName}</option>)}
                                    </Form.Select>
                                </InputGroup>
                            </Row>
                            <Row>
                                <InputGroup className="mb-2">
                                    <InputGroup.Text>SỐ TÀI KHOẢN</InputGroup.Text>
                                    <Form.Control
                                        value={payment.account_number}
                                        onChange={this.handleChangeAccountNumber}
                                    />
                                </InputGroup>
                            </Row>
                            <Row>
                                <InputGroup className="mb-2">
                                    <InputGroup.Text>SỐ TIỀN</InputGroup.Text>
                                    <Form.Control
                                        value={_formatCurrency(payment.amount)}
                                        disabled={true}
                                    />
                                </InputGroup>
                            </Row>
                            <Row>
                                <InputGroup className="mb-2">
                                    <InputGroup.Text>NỘI DUNG</InputGroup.Text>
                                    <Form.Control
                                        value={message}
                                        onChange={this.handleChangeMessage}
                                    />
                                </InputGroup>
                            </Row>
                            <Row>
                                <Col md="12" className="mb-2 text-center">
                                    <Button
                                        className="btn-fill pull-right ml-3 btn-lg"
                                        type="submit"
                                        variant="primary"
                                        onClick={this.handleSubmit}
                                        style={{ "padding": "5px" }}
                                    >
                                        Lưu
                                    </Button>

                                    <Button
                                        className="btn-fill pull-right ml-3 btn-lg"
                                        type="submit"
                                        variant="danger"
                                        onClick={this.handleConfirmPayment}
                                        style={{ "padding": "5px" }}
                                    >
                                        Xác Nhận CK
                                    </Button>
                                </Col>
                            </Row>
                        </Col>
                        <Col md="5">
                            <div className="qr-container">
                                <QRCodeCanvas value={this.renderQR(payment)} size={256} />
                            </div>
                        </Col>
                    </Row>
                </Col>
            </Row>
        );
    }
}

const mapStateToProps = (state) => {
    return {
    }
}

export default connect(mapStateToProps, {
    updateAutoP2PPayment
})(AutoP2PPayment);